import { dataAlignBottom } from 'dls-icons-data'
import { createIcon } from '../common'

const IconAlignBottom = /*#__PURE__*/createIcon(dataAlignBottom)
export default IconAlignBottom
